export default __webpack_public_path__ + "static/media/life-ring.9ed807d5.svg";